import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AutoOfferListRoute from "./offer-list";
import Header from "../../components/Header";
import { PHASE } from "../../routeConfig";
import SelectAutoIssuerRoute from "./select-issuer";
import UnlinkedApplicationAutoRoutes from "./unlinked-application";
var ExistingCustomer = React.lazy(function () {
    return import(/* webpackChunkName: "ExistingCustomer" */ "./existing-customer");
});
var AuthCompleteRoute = React.lazy(function () { return import(/* webpackChunkName: "AuthComplete" */ "./auth-complete"); });
var AutoPoliciesLoadingRoute = React.lazy(function () {
    return import(/* webpackChunkName: "AutoPoliciesLoading" */ "./policies-loading");
});
var AutoPoliciesLoadedRoute = React.lazy(function () {
    return import(/* webpackChunkName: "AutoPoliciesLoaded" */ "./policies-loaded");
});
var AutoPoliciesMissingData = React.lazy(function () {
    return import(
    /* webpackChunkName: "AutoPoliciesMissingData" */ "./policies-missing-data");
});
var CredentialsRoute = React.lazy(function () { return import(/* webpackChunkName: "Credentials" */ "./credentials"); });
var ForgotPasswordRoute = React.lazy(function () { return import(/* webpackChunkName: "ForgotPassword" */ "./forgot-password"); });
var HaveLoginRoute = React.lazy(function () { return import(/* webpackChunkName: "Havelogin" */ "./have-login"); });
var UnsupportedIssuerRoute = React.lazy(function () {
    return import(/* webpackChunkName: "UnsupportedIssuer" */ "./unsupported-issuer");
});
var UnqualifiedRoute = React.lazy(function () { return import(/* webpackChunkName: "Unqualified" */ "./unqualified"); });
var IntroRoute = React.lazy(function () { return import(/* webpackChunkName: "Intro" */ "./intro"); });
var IssuerWebsiteRoute = React.lazy(function () { return import(/* webpackChunkName: "IssuerWebsite" */ "./issuer-website"); });
var RememberLoginRoute = React.lazy(function () { return import(/* webpackChunkName: "RememberLogin" */ "./remember-login"); });
export default function AutoRoutes() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: PHASE.INTRO },
            React.createElement(Header, null),
            React.createElement(IntroRoute, null)),
        React.createElement(Route, { path: PHASE.SELECT_AUTO_ISSUER },
            React.createElement(SelectAutoIssuerRoute, null)),
        React.createElement(Route, { path: PHASE.HAVE_LOGIN },
            React.createElement(HaveLoginRoute, null)),
        React.createElement(Route, { path: PHASE.REMEMBER_LOGIN },
            React.createElement(RememberLoginRoute, null)),
        React.createElement(Route, { path: PHASE.ENTER_CREDENTIALS },
            React.createElement(CredentialsRoute, null)),
        React.createElement(Route, { path: PHASE.COMPLETE },
            React.createElement(AuthCompleteRoute, null)),
        React.createElement(Route, { path: PHASE.POLICIES_LOADING },
            React.createElement(AutoPoliciesLoadingRoute, null)),
        React.createElement(Route, { path: PHASE.POLICIES_LOADED },
            React.createElement(AutoPoliciesLoadedRoute, null)),
        React.createElement(Route, { path: PHASE.AUTO_POLICIES_MISSING_DATA },
            React.createElement(AutoPoliciesMissingData, null)),
        React.createElement(Route, { path: PHASE.FORGOT_PASSWORD },
            React.createElement(ForgotPasswordRoute, null)),
        React.createElement(Route, { path: PHASE.ISSUER_WEBSITE },
            React.createElement(Header, null),
            React.createElement(IssuerWebsiteRoute, null)),
        React.createElement(Route, { path: PHASE.UNSUPPORTED_ISSUER },
            React.createElement(UnsupportedIssuerRoute, null)),
        React.createElement(Route, { path: PHASE.UNQUALIFIED },
            React.createElement(Header, null),
            React.createElement(UnqualifiedRoute, null)),
        React.createElement(Route, { path: PHASE.EXISTING_CUSTOMER },
            React.createElement(Header, null),
            React.createElement(ExistingCustomer, null)),
        React.createElement(Route, { path: "".concat(path, "/unlinked-application") },
            React.createElement(UnlinkedApplicationAutoRoutes, null)),
        React.createElement(Route, { path: PHASE.AUTO_OFFER_LIST },
            React.createElement(AutoOfferListRoute, null))));
}
